export default __webpack_public_path__ + "static/media/P-015.d33cb0a6.png";